import { Person } from './../../shared/models/person.model';
import { Client } from './../../shared/models/client.model';
export class IsiClientReportDetail {
    clients: Array<Client>;
    isLoading = true;
    open = false;
}

export class IsiPersonReportDetail {
    person: Array<Person>;
    isLoading = true;
    open = false;
}

export class ISICountryWisePerson {
    data: any[];
    isLoading = true;
    open = false;
}

export class ISICountryWiseEntity {
    data: any[];
    isLoading = true;
    open = false;
}

export class ISIstructureWiseEntity {
    data: any[];
    isLoading = true;
    open = false;
}









// WEBPACK FOOTER //
// ./src/app/reports/isi-report-detail/isi-report-detail.model.ts